export function sortInventoryData({
  inventory,
  companyId,
  attribute,
  orderType,
}) {
  if (!Array.isArray(inventory)) {
    throw new Error('inventory no es un array válido')
  }

  if (!companyId || !attribute || !orderType) {
    throw new Error(
      'Todos los parámetros son requeridos: companyId, attribute, orderType'
    )
  }

  if (!['asc', 'desc'].includes(orderType.toLowerCase())) {
    throw new Error('orderType debe ser "asc" o "desc"')
  }

  const isAscending = orderType.toLowerCase() === 'asc'
  const sortedInventory = [...inventory]

  return sortedInventory.sort((a, b) => {
    const aIsTargetCompany = a.CompanyId === companyId
    const bIsTargetCompany = b.CompanyId === companyId

    if (aIsTargetCompany && !bIsTargetCompany) return -1
    if (!aIsTargetCompany && bIsTargetCompany) return 1

    const aValue = a[attribute]
    const bValue = b[attribute]

    if (aValue == null && bValue == null) return 0
    if (aValue == null) return isAscending ? 1 : -1
    if (bValue == null) return isAscending ? -1 : 1

    if (typeof aValue === 'number' && typeof bValue === 'number') {
      return isAscending ? aValue - bValue : bValue - aValue
    } else {
      const aStr = String(aValue).toLowerCase()
      const bStr = String(bValue).toLowerCase()
      return isAscending ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr)
    }
  })
}
